import { coreClient } from '../../../utils/request';
import { apiSettingsActions } from '../ducks';
import { store } from '../../..';
/**
 * Sandbox token + login + Redux success/failure flags.
 * Used by the LOGIN_SANDBOX_START listener and by {@link retrieveCurrentUser} without dispatching START (avoids duplicate runs).
 * Once `signal` is aborted, nothing more is dispatched or requested (as a cancelled saga did).
 */
export async function runSandboxLogin(signal?: AbortSignal): Promise<void> {
  const { dispatch } = store;
  try {
    const sandboxAuth = await coreClient.users.retrieveSandboxToken();
    if (signal?.aborted) return;
    dispatch(apiSettingsActions.setSandboxToken(sandboxAuth));
    await coreClient.users.login({ token: sandboxAuth.token });
    if (signal?.aborted) return;
    dispatch(apiSettingsActions.loginSandboxSuccess());
  } catch (e) {
    if (signal?.aborted) return;
    dispatch(apiSettingsActions.loginSandboxFailed());
  }
}
